export default __webpack_public_path__ + "static/media/ecma2.8a6123b9.jpeg";